module.exports = __webpack_public_path__ + "static/RootSans-2ThinItalic-4d5f67d3992353274fa1d0e1daf6f7b1.woff2";